var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TaiwanFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M34,6.697V24H4c0,11.046,8.954,20,20,20s20-8.954,20-20C44,16.602,39.972,10.157,34,6.697z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#303f9f",
    d: "M34,6.697C31.056,4.992,27.647,4,24,4C12.954,4,4,12.954,4,24h30V6.697z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.817,10.085L19,6l-0.817,4.085C18.447,10.03,18.72,10,19,10S19.553,10.03,19.817,10.085z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,7.072l1.341,3.963c0.408-0.366,0.89-0.644,1.422-0.819L15,7.072z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.072,10l3.144,2.763c0.175-0.533,0.452-1.014,0.819-1.422L12.072,10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.085,13.183L11,14l4.085,0.817C15.03,14.553,15,14.28,15,14S15.03,13.447,15.085,13.183z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.072,18l3.963-1.341c-0.366-0.408-0.644-0.89-0.819-1.422L12.072,18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,20.928l2.763-3.144c-0.533-0.175-1.014-0.452-1.422-0.819L15,20.928z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.183,17.915L19,22l0.817-4.085C19.553,17.97,19.28,18,19,18S18.447,17.97,18.183,17.915z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23,20.928l-1.341-3.963c-0.408,0.366-0.89,0.644-1.422,0.819L23,20.928z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.928,18l-3.144-2.763c-0.175,0.533-0.452,1.014-0.819,1.422L25.928,18z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.915,14.817L27,14l-4.085-0.817C22.97,13.447,23,13.72,23,14S22.97,14.553,22.915,14.817z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.928,10l-3.963,1.341c0.366,0.408,0.644,0.89,0.819,1.422L25.928,10z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23,7.072l-2.763,3.144c0.533,0.175,1.014,0.452,1.422,0.819L23,7.072z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 14,
    r: 3,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TaiwanFlag);
export default __webpack_public_path__ + "static/media/icons8-taiwan-flag.6ba5ef8c56001711d4908fcfeee0bb66.svg";
export { ForwardRef as ReactComponent };